module.exports = __webpack_public_path__ + "static/img/dandong.c731726.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/font/dandong.png
// module id = NySZ
// module chunks = 1